import styled from "@emotion/styled";
import iconCheckRounded from "atoms/icons/check_rounded.svg";
import { Button, FlexRow, Link, Text, TooltipPopup } from "atoms";
import { useAuth } from "features/auth";

type ProfileCompletePopupProps = {
  onCancel: VoidFunction;
};
function ProfileCompletePopup({
  onCancel,
  ...props
}: ProfileCompletePopupProps) {
  const { user } = useAuth();
  if (user) {
    return (
      <ProfileCompleteTooltip
        positionX="right"
        positionY="bottom"
        delay={3000}
        {...props}
      >
        <Text size="xs" bold>
          Finish setting up your profile
        </Text>

        <ul>
          <Text as="li" size="xs">
            <DisplayCheckbox checked /> Connect your wallet
          </Text>
          <Text as="li" size="xs">
            <DisplayCheckbox checked={!!user.name} />
            Create username
          </Text>
          <Text as="li" size="xs">
            <DisplayCheckbox checked={!!user.email} />
            Add email address
          </Text>
        </ul>

        <FlexRow justifyContent="space-between">
          <Link to="/profile/edit" size="sm">
            Edit profile
          </Link>
          <SButton variant="blank" size="sm" onClick={onCancel}>
            Later
          </SButton>
        </FlexRow>
      </ProfileCompleteTooltip>
    );
  }
  return null;
}

const ProfileCompleteTooltip = styled(TooltipPopup)(({ theme }) => ({
  transform: "translateY(5px)",

  [theme.breakpoints.mobile]: {
    animation: "none",
    "&::before, &::after": {
      display: "none",
      content: "none",
    },
  },
  "ul, li": {
    listStyleType: "none",
    margin: "1em 0",
    padding: 0,
  },
  li: {
    display: "flex",
    alignItems: "center",
    margin: ".3em 0",
  },
}));

const DisplayCheckbox = styled.span<{ checked: boolean }>(
  ({ checked, theme }) => ({
    display: "inline-flex",
    borderRadius: theme.borderRadius.xs,
    backgroundColor: "white",
    width: "1em",
    height: "1em",
    marginRight: 10,
    ...(checked === false && {
      backgroundColor: theme.colors.gray20,
      opacity: 0.5,
      mixBlendMode: "multiply",
    }),
    "&::after": {
      content: "''",
      backgroundImage: `url('${iconCheckRounded}')`,
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
      display: "inline-block",
      height: "100%",
      width: "100%",
      transform: "translateX(.2em) scale(1.15)",
      filter:
        "brightness(0) saturate(100%) invert(46%) sepia(28%) saturate(7415%) hue-rotate(353deg) brightness(101%) contrast(95%)",
      ...(checked === false && {
        color: theme.colors.black,
        filter: "none",
        opacity: 0.7,
      }),
    },
  })
);

const SButton = styled(Button)({
  "&, &:hover, &:focus-visible": {
    textDecoration: "underline",
    lineHeight: 1.5,
    borderRadius: 0,
  },
});

export { ProfileCompletePopup };
